'use client';

import { Stack } from '@/features/uiKit/Stack';
import { Text } from '@/features/uiKit/Text';
import { CheckCircle2 } from 'lucide-react';

export const AliasResultPreview = () => {
  return (
    <Stack
      sx={{
        width: '100%',
        maxWidth: '480px',
        borderRadius: '20px',
        overflow: 'hidden',
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.12)',
        backgroundColor: '#10131a',
        color: '#f4f4f5',
      }}
      role="img"
      aria-label="Alias game result showing the AI guessed sunshine correctly with speaking feedback"
    >
      <Stack
        sx={{
          padding: '16px 20px',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
        }}
      >
        <Text as="span" variant="label" color="inheritSecondary">
          See the AI&apos;s Guess
        </Text>
      </Stack>

      <Stack sx={{ padding: '24px 20px', gap: '18px' }}>
        <Stack sx={{ gap: '6px' }}>
          <Text as="span" variant="label" color="inheritSecondary">
            AI guessed
          </Text>
          <Text as="span" variant="title" color="inherit">
            Sunshine
          </Text>
        </Stack>

        <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
          <CheckCircle2 size={22} color="#22c55e" aria-hidden="true" />
          <Text variant="bodyMedium" color="success">
            Correct answer
          </Text>
        </Stack>

        <Stack
          sx={{
            backgroundColor: 'rgba(255,255,255,0.06)',
            borderRadius: '12px',
            padding: '14px 16px',
            gap: '6px',
          }}
        >
          <Text as="span" variant="label" color="inheritSecondary">
            Feedback
          </Text>
          <Text variant="small" color="inherit">
            You described the idea clearly and kept a natural pace. Try linking two related clues
            next round to stretch your vocabulary.
          </Text>
        </Stack>

        <Stack
          component="span"
          sx={{
            display: 'inline-flex',
            alignSelf: 'flex-start',
            padding: '10px 20px',
            borderRadius: '50px',
            border: '1px solid rgba(5, 172, 255, 0.5)',
            color: '#05acff',
          }}
        >
          <Text as="span" variant="smallMedium" color="inherit">
            Try Another Word
          </Text>
        </Stack>
      </Stack>
    </Stack>
  );
};
